import { AfterViewInit, Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from "@angular/core";
import { UntypedFormControl, UntypedFormGroup, ValidationErrors, ValidatorFn, Validators, FormsModule, ReactiveFormsModule } from "@angular/forms";
import { skip, Subscription } from "rxjs";
import { HandheldFormDirective } from "src/app/wings-mobile/directives/handheld-form.directive";
import { CaseTypeResponseModel } from "src/app/wings-mobile/models/case/case-type-response.model";
import { OutboundCasesTO } from "src/app/wings-mobile/models/dispatchingAndInvoicing/dispatch-and-invoice-response.model";
import { DispatchingInvoicingService } from "src/app/wings-mobile/services/outbound/dispatching-invoicing.service";
import { Globals } from "src/app/wings-mobile/shared/globals/globals";
import { CaseTypeInputValidator } from "src/app/wings-mobile/validators/case-type-input.validator";
import { RouteCurrent } from "../../dispatching-invoicing.component";
import { DialogModule } from "primeng/dialog";
import { LoadInfoDisplayComponent } from "../../load-info-display/load-info-display.component";
import { HandheldFormDirective as HandheldFormDirective_1 } from "../../../../../../directives/handheld-form.directive";
import { NgIf } from "@angular/common";
import { ButtonDirective } from "primeng/button";
import { TranslatePipe } from "@ngx-translate/core";

export class OutboundDimensionsCaseResponseTO {
	codeResponse: number;
	grossWeightA: number;
	totalGrossWeightA: number;
}

@Component({
    'selector': 'case-info-edition',
    'templateUrl': './case-info-edition.component.html',
    'styleUrls': ['./case-info-edition.component.scss'],
    imports: [DialogModule, LoadInfoDisplayComponent, FormsModule, HandheldFormDirective_1, ReactiveFormsModule, NgIf, ButtonDirective, TranslatePipe]
})
export class CaseInfoEditionComponent implements OnInit, AfterViewInit, OnDestroy {

	EXPORT_CASE_VALUE = 'Y';

	@Input() case: OutboundCasesTO;
	@Input() routeCurrent: RouteCurrent;
	@Input() exportF: string;

	@Output() onClose = new EventEmitter();
	@Output() successSaveCaseInfo = new EventEmitter();

	@ViewChild(HandheldFormDirective) handHeldForm: HandheldFormDirective;
	handheldFormInputEvent$: Subscription;

	newCase$: Subscription;
	newCase: CaseTypeResponseModel;
	// inputChangeEvents : any = {
	//   "caseType" : this.caseTypeChange.bind(this)
	// }

	formGroup: UntypedFormGroup;
	formGroupValues$: Subscription;
	minimumValueStillRequired: boolean = false;
	isBulkWithMaster: boolean = true;

	isWeightValidatorRunning = false;

	constructor(private globals: Globals, private caseValidator: CaseTypeInputValidator, private outboundDispatching: DispatchingInvoicingService) {
		this.globals = globals;
		this.caseValidator = caseValidator;
		this.outboundDispatching = outboundDispatching;
	}

	ngOnInit(): void {
		this.startFormGroup();
	}

	ngAfterViewInit(): void {
		// this.handheldFormInputEvent$ = this.handHeldForm.triggerValueEnter.subscribe((inputId)=>{
		//   if(this.inputChangeEvents[inputId]) this.inputChangeEvents[inputId]();
		// })
		this.newCase$ = this.caseValidator.newCase.pipe(
			skip(1),
		).subscribe((newCase) => {
			this.newCase = newCase;
			if (this.case.caseTypes.bkCaseTypeC != this.newCase.bkCaseTypeC) this.setNewBoxInfo();
		});
	}

	startFormGroup() {
		this.formGroup = new UntypedFormGroup({
			weight: new UntypedFormControl(this.case.grossWeightInformedA, [
				Validators.required,
				Validators.min(0.001),
				Validators.max(999.999),
			]),
			netWeight: new UntypedFormControl(this.case.netWeightA, [
				Validators.required,
				Validators.min(0.001),
				Validators.max(999.999),
			]),
			height: new UntypedFormControl(this.case.heightQ, [
				Validators.required,
				Validators.min(0.001),
				Validators.max(999.999)
			]),
			width: new UntypedFormControl(this.case.widthQ, [
				Validators.required,
				Validators.min(0.001),
				Validators.max(999.999)
			]),
			depth: new UntypedFormControl(this.case.depthQ, [
				Validators.required,
				Validators.min(0.001),
				Validators.max(999.999)
			])
		},
			{
				validators: [this.grossWeightValidator()],
				updateOn: 'change',
			})

		this.formGroup.valueChanges.subscribe(() => {
			let minimumRequired = false;
			for (let i in this.formGroup.controls) {
				if (this.formGroup.controls[i].errors && this.formGroup.controls[i].errors.min) {
					minimumRequired = true;
					break;
				}
			}


			this.minimumValueStillRequired = minimumRequired;
		})

		let caseTypeFormControl;
		if ((this.case.bulk_F === "BULK") && (this.exportF == this.EXPORT_CASE_VALUE)) {
			caseTypeFormControl = new UntypedFormControl({ value: this.case.caseTypes.bkCaseTypeC, disabled: true });
			this.isBulkWithMaster = false;
		} else {
			caseTypeFormControl = new UntypedFormControl(this.case.caseTypes.bkCaseTypeC, {
				validators: [
					Validators.required,
					Validators.minLength(2)
				],
				asyncValidators: [this.caseValidator.validate.bind(this.caseValidator)],
				updateOn: 'change'
			})

		}
		this.formGroup.addControl('caseType', caseTypeFormControl);
	}

	grossWeightValidator(): ValidatorFn {
		return (): ValidationErrors | null => {
			if (this.formGroup && this.formGroup.controls) {
				const controlWeight = this.formGroup.controls["weight"];
				const controlNetWeight = this.formGroup.controls["netWeight"];
				const grossWeight = controlWeight.value;
				const netWeightA = controlNetWeight.value;
				if (grossWeight < netWeightA) {
					let err = { grossWeightLessThanNetWeight: true };
					controlWeight.setErrors(err)
					return err;
				} else {
					controlWeight.setErrors(null)
				}
			}
			return null;
		};
	}

	setNewBoxInfo() {
		this.formGroup.controls["weight"].setValue(this.formGroup.controls["netWeight"].value + this.newCase.weigthQ);
		this.formGroup.controls["height"].setValue(this.newCase.heightQ);
		this.formGroup.controls["width"].setValue(this.newCase.widthQ);
		this.formGroup.controls["depth"].setValue(this.newCase.depthQ);
	}


	saveNewBoxInfo() {
		this.outboundDispatching.updateDimensionBox({
			subDivisionUidD: this.globals.user.warehouse.bkSubDivisionUidD,
			bkCaseR: this.case.bkCaseR,
			caseTypeUidD: (this.newCase && this.newCase.caseTypeUidK) ? this.newCase.caseTypeUidK : 0,
			grossWeightInformedA: this.formGroup.controls["weight"].value,
			netWeightA: this.formGroup.controls["netWeight"].value,
			sizeUnityOfMeasureC: "M",
			heightQ: this.formGroup.controls["height"].value,
			widthQ: this.formGroup.controls["width"].value,
			depthQ: this.formGroup.controls["depth"].value,
			weigthUnitOfMeasureC: "Kg",
			outboundLoadUidK: this.routeCurrent.outboundLoadUidK,
			oldGrossWeightInformedA: this.routeCurrent.oldGrossWeightInformedA,
			totalGrossWeightA: this.routeCurrent.totalGrossWeightA
		}).subscribe((response: OutboundDimensionsCaseResponseTO) => {
			if (response) {
				this.routeCurrent.oldGrossWeightInformedA = response.grossWeightA;
				this.routeCurrent.totalGrossWeightA = response.totalGrossWeightA;
				this.emitSuccessSave();
				this.closeModal();
			}
		}
		);
	}

	emitSuccessSave() {
		this.successSaveCaseInfo.emit();
	}

	closeModal() {
		this.onClose.emit();
	}

	ngOnDestroy(): void {
		if (this.newCase$) this.newCase$.unsubscribe();
		if (this.formGroupValues$) this.formGroupValues$.unsubscribe();
		if (this.handheldFormInputEvent$) this.handheldFormInputEvent$.unsubscribe();
	}
}

